import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, InputGroup, Spinner } from 'react-bootstrap'
import Api from '../Services/api/api';
import { Context } from '../Components/Context';
import ApplicantsSummary from '../Components/ApplicantsSummary';
import PlanDetails from '../Components/PlanDetails';

const PlanSelect = (props) => {
    const { effectiveDate, selectedCounty, applicants, setApplicants, selectedPlan, setSelectedPlan } = useContext(Context);

    const navigate = useNavigate();

    const [state, setState] = useState({
        maxPremiumFilter: 0,
        maxOutOfPocketFilter: 0,
        planSort: 'premium',
        modalShow: false,
        plans: [],
        loadingPlans: false
    });

    useEffect(() => {
        if (!applicants?.length || !applicants[0]?.sex) {
            navigate('/');
        }

        // Sort applicants by type, then age, then id
        setApplicants(applicants.sort(sortByTypeThenAgeThenId));

        Api.getPlanRates({ effectiveDate, selectedCounty, applicants },
            {
                onInit: () => setState({ ...state, loadingPlans: true }),
                onComplete: () => setState({ ...state, loadingPlans: false })
            })
            .then(data => {
                if (data) {

                    setState({ ...state, plans: data });
                }
            })
            .catch(err => console.log(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeFilter = (event, field) => {
        setState({
            ...state,
            [field]: event.target.value
        });
    };

    const toggleModal = () => {
        setState({
            ...state,
            modalShow: !state.modalShow
        })
    };

    const handleSelectPlan = (plan) => {
        setSelectedPlan(plan);
        navigate('/Application');
    }

    const filteredPlans = () => {
        let plans = state.plans;
        if (state.maxPremiumFilter > 0) {
            plans = plans.filter(x => parseFloat(x.rate) <= parseFloat(state.maxPremiumFilter));
        }
        if (state.maxOutOfPocketFilter > 0) {
            plans = plans.filter(x => parseFloat(x.maxOutOfPocketPerPerson) <= parseFloat(state.maxOutOfPocketFilter));
        }

        return plans;
    }

    const sortPlans = (a, b) => {
        let func = (x) => x;

        let prop = 'rate';
        switch (state.planSort) {
            case 'deductible':
                prop = 'deductible';
                break;
            case 'maxOutOfPocket':
                prop = 'maxOutOfPocketPerPerson';
                func = (x) => Number(x);
                break;
            case 'name':
                prop = 'planName';
                break;
            default:
                break;
        }
        return func(a[prop]) < func(b[prop]) ? -1 : func(a[prop]) > func(b[prop]) ? 1 : a.id - b.id;
    }

    const typeMap = {
        'Primary': 0,
        'Spouse': 1,
        'Dependent': 2
    };

    const sortByTypeThenAgeThenId = (a, b) => {
        if (typeMap[a.type] < typeMap[b.type]) {
            return -1;
        } else if (typeMap[a.type] > typeMap[b.type]) {
            return 1;
        } else if (a.age < b.age) {
            return -1;
        } else if (a.age > b.age) {
            return 1;
        } else {
            return a.id - b.id;
        }
    }

    return (
        <section className='plan-results'>
            <Container fluid className='min-vh-100 d-flex flex-column'>
                <Row className='flex-grow-1'>
                    <Col lg={3} xl={2} className='border-end'>
                        <Row className='plan-details'>
                            <Col sm={12}>
                                <ApplicantsSummary effectiveDate={effectiveDate} county={selectedCounty} applicants={applicants} />
                            </Col>
                            <Col sm={12}>
                                <div className='py-3 border-bottom'>
                                    <Row>
                                        <h6>Filters</h6>
                                    </Row>
                                    <Row className="py-1">
                                        <Col>
                                            <Form.Label htmlFor="premium-filter-max">Monthly premium max</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control id="premium-filter-max" type="number" min={0} max={10000} step={100} value={state.maxPremiumFilter} onChange={(e) => handleChangeFilter(e, 'maxPremiumFilter')} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <Row className="py-1">
                                        <Col>
                                            <Form.Label htmlFor="out-of-pocket-max">Out-of-pocket max</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control id="out-of-pocket-filter-max" type="number" min={0} max={10000} step={100} value={state.maxOutOfPocketFilter} onChange={(e) => handleChangeFilter(e, 'maxOutOfPocketFilter')} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={9} xl={10} className='plans-desc'>
                        <Row className='align-items-center'>
                            {state.loadingPlans ? (
                                <Col sm={12} className='mt-5 text-center'>
                                    <Spinner animation="border" role="status">
                                    </Spinner>
                                    <div className='text-center'>Loading</div>
                                </Col>
                            ) : (
                                <>
                                    <Col lg={9}>
                                        <h6 className='my-2'>Showing {filteredPlans().length} of {state.plans.length} Plans</h6>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group controlId="plan-sort">
                                            {/*<Form.Label>Sort Plans</Form.Label>*/}
                                            <Form.Select className='my-2 select-variant' value={state.planSort} onChange={(e) => setState({ ...state, planSort: e.target.value })}>
                                                <option value="premium">Sort by Premium</option>
                                                <option value="name">Sort by Plan name</option>
                                                {/*<option value="deductible" disabled>Sort by Deductible</option>*/}
                                                <option value="maxOutOfPocket">Sort by Max out-of-pocket</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {filteredPlans().length ? (
                                        filteredPlans().sort(sortPlans).map((plan, index) => (
                                            <Col sm={12} key={index} className='mt-4'>
                                                <PlanDetails plan={plan} handleToggleModal={toggleModal} isSelected={selectedPlan?.id === plan.id} handleSelect={() => handleSelectPlan(plan)} />
                                            </Col>
                                        ))
                                    ) : (
                                        <Col sm={12} className='mt-4'>
                                            <div className='text-center'>No plans found that matched the criteria</div>
                                        </Col>
                                    )}
                                </>
                            )}
                        </Row>
                    </Col>
                </Row>
            </Container>
            {/*<Modal className='view-cart' centered show={state.modalShow} onHide={toggleModal}>*/}
            {/*    <Modal.Header closeButton>*/}
            {/*        <Modal.Title><i className='bx bx-cart'></i>Cart</Modal.Title>*/}
            {/*    </Modal.Header>*/}
            {/*    <Modal.Body>*/}
            {/*        <Row>*/}
            {/*            <Col sm={12} className='border-bottom py-2'>*/}
            {/*                <Row>*/}
            {/*                    <Col lg={2}>*/}
            {/*                        <CloseButton />*/}
            {/*                    </Col>*/}
            {/*                    <Col lg={6}>*/}
            {/*                        <p>Bronze Value 1814($ Preventive Care) </p>*/}
            {/*                    </Col>*/}
            {/*                    <Col lg={4}>*/}
            {/*                        <div className='price-list'>*/}
            {/*                            <div className='curr-price'>$208.42 /mo</div>*/}
            {/*                            <del className='old-price'>$979.42 /mpo</del>*/}
            {/*                        </div>*/}
            {/*                    </Col>*/}
            {/*                </Row>*/}
            {/*            </Col>*/}
            {/*            <Col sm={12} md={6} className='pt-3'>*/}
            {/*                <div className='fs-6'>Total premium</div>*/}
            {/*            </Col>*/}
            {/*            <Col sm={12} md={6} className='pt-3 text-end'>*/}
            {/*                <div className='fs-5 fw-semibold'>$208.42 /mo</div>*/}
            {/*            </Col>*/}
            {/*        </Row>*/}
            {/*    </Modal.Body>*/}
            {/*    <Modal.Footer>*/}
            {/*        <Button variant="outline-primary" onClick={toggleModal}>*/}
            {/*            Continue shopping*/}
            {/*        </Button>*/}
            {/*        <Button variant="primary" onClick={startApplication}>*/}
            {/*            Start Application*/}
            {/*        </Button>*/}
            {/*    </Modal.Footer>*/}
            {/*</Modal>*/}
        </section>
    )
}

export default PlanSelect;
